import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { profileService } from '../../../services/profile'
import { useGlobalStore } from '../../../store/global-store'

export const USER_COINS_QUERY_KEY = ['getUserCoins']

export const useGetUserCoins = () => {
  const queryClient = useQueryClient()

  const handleRefetch = useCallback(async () => {
    const response = await queryClient.fetchQuery({
      queryKey: USER_COINS_QUERY_KEY,
      queryFn: profileService.getCoins,
    })

    const userCoins = response?.data?.coins

    useGlobalStore.setState({ coinsInLive: userCoins })
  }, [queryClient])

  return {
    refetch: handleRefetch,
  }
}
